import {
  GetCompanyContextResponse,
  UpdateCompanyContextRequest,
  UpdateCompanyContextResponse,
  UpdateCurrentObjectiveRequest,
  UpdateCurrentObjectiveResponse,
} from '@customTypes/companyContext/CompanyContext';
import ApiService from './ApiService';

class CompanyService {
  // Get company context
  public async getCompanyContext(): Promise<
    GetCompanyContextResponse | undefined | null
  > {
    const { success, data, error } =
      await ApiService.get<GetCompanyContextResponse>(`/company/summary`);

    if (success) {
      const { company_summary_json, ...rest } = data || {};

      if (company_summary_json && typeof company_summary_json === 'string') {
        let context = JSON.parse(company_summary_json);

        // Filter out keys starting with underscore (internal/metadata fields)
        context = Object.keys(context)
          .filter(key => !key.startsWith('_'))
          .reduce((acc: any, key: string) => {
            return {
              ...acc,
              [key]: {
                title: key,
                content: context[key],
              },
            };
          }, {});
        return {
          ...rest,
          company_summary_json: context,
        } as GetCompanyContextResponse;
      }
    } else {
      throw new Error(error || 'Failed to fetch company context');
    }
  }

  // Update company context
  public async updateCompanyContext(
    requestPayload: UpdateCompanyContextRequest,
  ): Promise<UpdateCompanyContextResponse> {
    const response = await ApiService.put<
      UpdateCompanyContextRequest,
      UpdateCompanyContextResponse
    >(`/company/summary`, requestPayload);

    if (response.success && response.data) {
      return response.data;
    } else {
      throw new Error(response.error || 'Failed to update company Context');
    }
  }
  public async updateCurrentObjective(
    requestPayload: UpdateCurrentObjectiveRequest,
  ): Promise<UpdateCurrentObjectiveResponse> {
    const response = await ApiService.put<
      UpdateCurrentObjectiveRequest,
      UpdateCurrentObjectiveResponse
    >(`/summary/priority`, requestPayload);
    if (response.success) {
      return response.data as UpdateCurrentObjectiveResponse;
    } else {
      throw new Error(response.error || 'Failed to update current objective');
    }
  }
}

export default new CompanyService();
